export default "__VITE_ASSET__BjFXjqTT__"